import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
import QualityCertificateReport from "./QualityCertificateReport"
import ItemService from "../../../../services/commonService";
import PrintMultipleQCReports from "./PrintMultipleQCReports";
import { formatDateTime } from "../../../../common/Validations";
import PrintQaulityCertificateLabel from "./PrintQualityCertificateLabel";

const QualityCertificate = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [displayReport, setDisplayReport] = useState(false);
  const [printMultipleReport, setPrintMultipleReport] = useState(false);
  const [row, setRow] = useState([]);
  const [report, setReport] = useState();
  const [reportList, setReportList] = useState([]);

  const [selectedJobcardRows, setSelectedJobcardRows] = useState([]);
 const [printQaulityCertificateLabel, setPrintQaulityCertificateLabel] = useState(false);

  const handleViewReport = (row) => {
    setDisplayReport(true);
    setRow(row);
  }

  const handleEditReport = async (row) => {
    let param = {
      url: "fetchQCReport",
      page: Constants.REPORTS.QUALITYCERTIFICATE.name,
      jobcard: row.jobcard
    };
    await ItemService.fetchQCReport(param).then((item) => {
      if (item?.status === 200) {
        setReport(item.data[0]);
        setDisplayReport(true);
        setRow(row);
      }
    });
  };

  const handleRowSelected = ({ selectedRows }) => {
    setSelectedJobcardRows(selectedRows);
  };

  const handlePrintReport = async () => {
    let param = {
      url: "getQCReportByJobCard",
      page: Constants.REPORTS.QUALITYCERTIFICATE.name,
      jobcards: selectedJobcardRows.map((item) => item.jobcard)
    };
    await ItemService.fetchQCReport(param).then((item) => {
      if (item?.status === 200) {
        setReportList(item.data);
        setPrintMultipleReport(true);
      }
    });
  }

  const handlePrintLabel = async (row) => {
    setRow(row);
    setPrintQaulityCertificateLabel(true)
  }

  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.sizeCode}</p>
        </div>
      ),
    },
    {
      name: "Completed Date",
      selector: (row) => row.createdDateFromOC,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.createdDateFromOC)}</p>
        </div>
      ),
    },
    {
      name: "Report Generated",
      selector: (row) => row.qcReportGeneratedDate,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.qcReportGeneratedDate
              ? formatDateTime(row.qcReportGeneratedDate)
              : "-"}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_customer"),
      selector: (row) => row.customerName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.customerName}</p>
        </div>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.qcReportGenerated,
      cell: (row) => (
        <>
          {row.qcReportGenerated ? (
            <span className="bg-table-status bg-table-success-status">
              Ready For Print
            </span>
          ) : (
            <></>
          )}
        </>
      ),
      center: true,
      width: "200px",
    },
    
    {
      name: t("msg_reports.quality_certificate.quality_report"),
      selector: (row) => row.qcReportGenerated,
      cell: (row) => (
        <>
          {row.qcReportGenerated ?
            (<button className="btn btnTable btn-approve" onClick={() => handleEditReport(row)}>
              {t("msg_reports.quality_certificate.edit_quality_report")}
            </button>
            ) : (
              <button className="btnTable" onClick={() => handleViewReport(row)}>
                {t("msg_reports.quality_certificate.view_quality_report")}
              </button>
            )
          }
        </>
      ),
      
      center: true,
      width: "200px",
    },
    {
      name: "Label Print",
      selector: (row) => row.qcReportGenerated,
      cell: (row) => (
        <>
          {
            (<button className="btn btnTable" onClick={() => handlePrintLabel(row)}>
               <i className="bi bi-printer"></i> {"Print"}
            </button>
            ) 
          }
        </>
      ),
      center: true,
      width: "130px",
    },
  ];


  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t(
                "msg_reports.quality_certificate.quality_certificate_reports"
              )}
            </h2>
            <p className="subText">
              {t("msg_reports.quality_certificate.quality_certificate_reports_details_page")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i class="bi bi-filter"> </i>
          </Button>

          <Button
            type="button"
            variant="primary"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={handlePrintReport}
            disabled={!selectedJobcardRows.length}
          >
            <i className="bi bi-printer"></i> {"Print"}
          </Button>
        </Col>
        <hr />
      </Row>

      <div>
        <ReportList
          columnsData={columnsData}
          displayProdStatusFilter={displayFilter}
          deptOptionReq={false}
          jobcardStatusReq={false}
          rowsData={row}
          resetFilerBox={setDisplayFilter}
          pageName={t(
            "msg_reports.quality_certificate.quality_certificate_reports_pageName"
          )}
          pageURL={Constants.REPORTS.QUALITYCERTIFICATE.list}
          name={Constants.REPORTS.QUALITYCERTIFICATE.name}
          selectableRows
          enableRowSelection={row => !row.qcReportGenerated}
          handleSelections={handleRowSelected}
        />
      </div>
      {
        displayReport && (
          <div>
            <QualityCertificateReport
              show={displayReport}
              report={report}
              onHide={() => {setDisplayReport(false);setReport()}}
              row={row}
            >
            </QualityCertificateReport>
          </div>
        )
      }
      {
        printMultipleReport && (
          <div>
            <PrintMultipleQCReports
              show={printMultipleReport}
              reportList={reportList}
              jobcardRows={selectedJobcardRows}
              onHide={() => {setPrintMultipleReport(false); setReportList([])}}
            >
            </PrintMultipleQCReports>
          </div>
        )
      }
      {printQaulityCertificateLabel && (
        <PrintQaulityCertificateLabel
          //printLabel={printLabel}
          show={printQaulityCertificateLabel}
          //jobcard={jobcard}
          row={row}
          onHide={() => {setPrintQaulityCertificateLabel(false); }}
        ></PrintQaulityCertificateLabel>
      )}
    </main>
  );
};

export default QualityCertificate;
